import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { reports } from "../../../components/Report.js";
export default class Billings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_view: false,

      filter_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_warehouse_id: "",

      data: [],
      data_customer: [],
      data_warehouse: [],
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_date, filter_warehouse_id } = this.state;
    let data, data_customer, data_warehouse;
    loading(true);
    let [result_sale, result_customer, result_warehouse] = await Promise.all([
      GET("admin/sales/list", {
        page: 0,
        data_search: "",
        start_date: format_date(filter_date, "yyyy-mm-dd", "en"),
        end_date: format_date(filter_date, "yyyy-mm-dd", "en"),
        warehouse_id: filter_warehouse_id,
        payment_type: "",
        status_code: "รอชำระ,ใบแจ้งหนี้,เสร็จสิ้น,ยกเลิก",
        withdrawal_type: "ขายหน้าร้าน,รอสั่งสินค้า",
      }),
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
    ]);
    if (result_sale?.status) {
      data = result_sale.data;
    }
    if (result_customer?.status) {
      data_customer = result_customer.data;
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    console.log("data:",data)
    this.setState({ data, data_customer, data_warehouse });
    loading(false);
  };

  ExportPDF = async () => {
    const table = this.tableRef.current;
    if (!table) return [];

    const rows = Array.from(table.querySelectorAll("tbody tr"));

    const data_list = rows.map((tr) => {
      const cells = Array.from(tr.querySelectorAll("td"));
      return cells.map((td) => td.innerText.trim());
    });

    const obj = {
      table: {
        headerRows: 1,
        widths: ["auto", 140, 65, 65, 65, 65],
        body: [
          [
            { text: "รหัสลูกค้า", alignment: "center" },
            { text: "ชื่อเต็มลูกค้า", alignment: "center" },
            { text: "ยอดหนี้ยกมา", alignment: "center" },
            { text: "ยอดขายในงวด", alignment: "center" },
            { text: "ยอดชำระ/ลดหนี้", alignment: "center" },
            { text: "ยอดหนี้ยกไป", alignment: "center" },
          ],
          ...data_list.map((item, index) => {
            let border = [1, 0, 1, 0];
            let color = "#ffffff";
            if (index === data_list.length - 1) {
              border = [1, 0, 1, 1];
            }
            return [
              {
                text: item[0],
                alignment: "left",
                fillColor: color,
                border: [1, border[1], border[2], border[3]],
              },
              { text: item[1], alignment: "left", fillColor: color, border },
              { text: item[2], alignment: "right", fillColor: color, border },
              { text: item[3], alignment: "right", fillColor: color, border },
              { text: item[4], alignment: "right", fillColor: color, border },
              {
                text: item[5],
                alignment: "right",
                fillColor: color,
                border: [border[0], border[1], 1, border[3]],
              },
            ];
          }),
        ],
      },
    };
    reports("รายงานสถานะลูกหนี้ทั้งหมด", obj, 14, "portrait");
  };
  render() {
    const {
      filter_date,
      filter_warehouse_id,
      data,
      data_customer,
      data_warehouse,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายงานต่อวันเฉพาะลูกหนี้</h4>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_date: e.target.value });
                }}
                value={filter_date}
              />
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>

              <div className="ms-auto">
                <button
                  className="btn btn-warning px-3 mb-2 me-2"
                  onClick={() => this.ExportPDF()}
                >
                  Export PDF
                </button>
                <DownloadTableExcel
                  filename="รายการสถานะลูกหนี้"
                  sheet="รายการสถานะลูกหนี้"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>
            <div className="table-responsive" style={{ maxHeight: "70vh" }}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                <thead>
                  <tr>
                    <td className="text-nowrap text-center">สถานะ</td>
                    <td className="text-nowrap text-center">วันที่</td>
                    <td className="text-nowrap text-center">เลขที่</td>
                    <td className="text-nowrap text-center">รหัสลูกค้า</td>
                    <td className="text-nowrap text-center">ชื่อลูกค้า</td>
                    <td className="text-nowrap text-center"></td>
                    <td className="text-nowrap text-center">มูลค่าก่อนหักส่วนลด</td>
                    <td className="text-nowrap text-center">ส่วนลด</td>
                    <td className="text-nowrap text-center">VAT</td>
                    <td className="text-nowrap text-center">รวมเงิน</td>
                    <td className="text-nowrap text-center">เงินมัดจำ</td>
                    <td className="text-nowrap text-center">ครบกำหนด</td>
                    <td className="text-nowrap text-center">เลขที่อ้างอิง</td>
                  </tr>
                </thead>
                
                  {data?.map((item, index) => (
                    <tbody>
                      <tr>
                        <td className="text-nowrap text-center">{item.status}</td>
                        <td className="text-nowrap text-center">{format_date(item.created_at,"dd/mm/yyyy")}</td>
                        <td className="text-nowrap text-center">{item.document_no}</td>
                        <td className="text-nowrap text-center">{item.customer?.customer_code || ""}</td>
                        <td className="text-nowrap text-start" colSpan={2}>{item.customer?.full_name || ""}</td>
                        <td className="text-nowrap text-end">{toFixed(item.amount)}</td>
                        <td className="text-nowrap text-end">{toFixed(item.discount)}</td>
                        <td className="text-nowrap text-end">{toFixed(item.vat)}</td>
                        <td className="text-nowrap text-end">{toFixed(Number(item.amount_net) + Number(item.vat))}</td>
                        <td className="text-nowrap text-end">{toFixed(item.amount_deposit)}</td>
                        <td className="text-nowrap text-center">{item.due_date ? format_date(item.due_date,"dd/mm/yyyy") : ""}</td>
                        <td className="text-nowrap text-center">{item.ref_number || ""}</td>
                      </tr>
                      <tr>
                        <td className="text-nowrap text-center"></td>
                        <td className="text-nowrap text-center">อันดับ</td>
                        <td className="text-nowrap text-center" colSpan={2}>รหัสสินค้า</td>
                        <td className="text-nowrap text-center">ชื่อสินค้า</td>
                        <td className="text-nowrap text-center">รหัสคลัง</td>
                        <td className="text-nowrap text-center" colSpan={2}>จำนวน</td>
                        <td className="text-nowrap text-center">ราคา</td>
                        <td className="text-nowrap text-center" colSpan={2}>ส่วนลด</td>
                        <td className="text-nowrap text-center" colSpan={2}>เป็นเงิน</td>
                      </tr>
                      {item.transaction_list.map((product, product_index) => (
                        <tr>
                          <td className="text-nowrap text-center"></td>
                          <td className="text-nowrap text-center">{product_index + 1}</td>
                          <td className="text-nowrap text-center" colSpan={2}>{product.product_code}</td>
                          <td className="text-nowrap text-center">{product.product_name}</td>     
                          <td className="text-nowrap text-center">{item.warehouse?.uid}</td>
                          <td className="text-nowrap text-center" colSpan={2}></td>
                          <td className="text-nowrap text-center"></td>
                          <td className="text-nowrap text-center" colSpan={2}></td>
                          <td className="text-nowrap text-center" colSpan={2}></td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={13} className="bg-dark p-0" style={{height:2}}></td>
                      </tr>
                    </tbody>
                  ))}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
